export const INVENTORY_CUSTOMIZED_REPORT_NAME_DAILY =
  'LOCATION_INVENTORY_DAILY_TABLE'
export const INVENTORY_CUSTOMIZED_REPORT_NAME_WEEKLY =
  'LOCATION_INVENTORY_WEEKLY_TABLE'
export const INVENTORY_CUSTOMIZED_REPORT_NAME_PERIOD =
  'LOCATION_INVENTORY_PERIOD_TABLE'
export const PURCHASE_CUSTOMIZED_REPORT_NAME = 'BK_LOCATION_PURCHASE_TABLE'
export const PURCHASE_CUSTOMIZED_REPORT_NAME_WITH_VENDOR =
  'BK_LOCATION_PURCHASE_TABLE_WITH_VENDOR'
